import { useEffect, useState } from "react"
import { getRateCodeInventorydelivery } from "../../../../../services/rateCodeService"

const useGetRateCodeInventorydelivery = (supplierProductCode = '') => {
    const [status, setStatus] = useState(true);
    useEffect(() => {
        const fetchStatus = async () => {
            try {
                const response = await getRateCodeInventorydelivery(supplierProductCode);
                setStatus(response.data.data)
            } catch (error) {
                setStatus(false)
            }
        }
        fetchStatus();
    }, [supplierProductCode])

    return [status]
}

export default useGetRateCodeInventorydelivery;